import { Dictionary } from '@/composables/advert/advertManager'
import { StatusCodes } from '@/composables/api'

export class ApiTimeout {
  domain: string
  permanent: boolean
  timeout: number
  stamp: number
  responseCodes: Array<StatusCodes>

  constructor(
    domain: string,
    permanent = true,
    timeout = 5,
    responseCodes = [StatusCodes.OK]
  ) {
    this.domain = domain
    this.permanent = permanent
    this.timeout = timeout
    this.stamp = new Date().getTime() / 1000
    this.responseCodes = responseCodes
  }
}

let timeoutList: Dictionary<ApiTimeout> = {}
const MAX_ITEMS = 20

export default function useApiTimeout() {
  const canCallApi = (apiTimeout: ApiTimeout) => {
    if (apiTimeout.domain in timeoutList) {
      if (timeoutList[apiTimeout.domain].permanent) {
        return false
      }

      if (
        timeoutList[apiTimeout.domain].stamp +
          timeoutList[apiTimeout.domain].timeout <
        new Date().getTime() / 1000
      ) {
        delete timeoutList[apiTimeout.domain]

        return true
      }

      return false
    }
    return true
  }

  const clearTimeouts = () => {
    timeoutList = {}
  }

  const addTimeout = (apiTimeout: ApiTimeout) => {
    if (Object.keys(timeoutList).length >= MAX_ITEMS) {
      clearTimeouts()
    }
    timeoutList[apiTimeout.domain] = apiTimeout
  }

  return {
    clearTimeouts,
    canCallApi,
    addTimeout,
  }
}
